import Nav from "../layout/nav/desktopNav";
import MobileNav from "../layout/nav/mobileNav";
import Footer from "../components/footer/Footer.js";
import Overview from "../components/references/oveview.js";
import Header from "../components/page-title/header.js";
import Data from "../components/references/data/Data.js";

function References() {
  return (
    <div>
      <Nav />
      <MobileNav />

      <Header
        height={40}
        heightState={true}
        title="Projecten"
        text="Neem een moment om onze projecten te verkennen en ontdek waarom samenwerken met Decoratie Degezelle een positieve impact heeft."
      />
      <Overview items={Data} />
      <Footer />
    </div>
  );
}

export default References;
